import styled from 'styled-components';
import Button from 'components/button/Button';
import { SidePanelContainerStyled } from 'components/sidePanel/SidePanel.styles';
import mediaQuery from 'styles/mediaQuery';

export const MenuButtonStyled = styled(Button)`
  border: none;
  flex-basis: 40px;
  font-size: 20px;
  height: 40px;
  margin-top: 3px;
  padding: 1px 5px;
`;

export const AutomationsHeaderContainer = styled.div`
  ${SidePanelContainerStyled} {
    max-width: 60vw;

    ${mediaQuery.custom(575)} {
      margin-top: 60px;
    }
  }
`;
